<template>
  <div @click="copy" class="relative">
    <slot></slot>
    <div class="w-full overflow-hidden relative">
      <input class="opacity-0 absolute" :value="link" />
    </div>
    <span class="copied-text" :class="{ 'animate-up' : copied }">Copied!</span>
  </div>
</template>

<script>
export default {
  name: 'CopyLink',
  props: ['link'],

  data () {
    return {
      copied: false
    }
  },

  mounted () {
    this.$el.querySelector('.copied-text')
      .addEventListener('animationend', () => {
        this.copied = false
      })
  },

  methods: {
    copy () {
      this.$el.querySelector('input').select()
      document.execCommand('copy')
      this.copied = true
    }
  }
}
</script>

<style scoped>

.copied-text {
  @apply w-full text-sm pin-l pin-t absolute text-center hidden
}

@keyframes animate-up {
  0% {
    opacity: 0;
    margin-top: 0;
  }

  50% {
    opacity: 1;
  }

  75% {
    margin-top: -2.5rem;
  }

  100% {
    opacity: 0;
    margin-top: -2.5rem;
  }
}

.animate-up {
  display: inline !important;
  animation: animate-up 2s;
}
</style>
